import { isRecord } from 'utils/typeChecks';

interface HeliosValidationErrorItem {
  errorMessage?: string;
}

function isHeliosValidationErrorItem(value: unknown): value is HeliosValidationErrorItem {
  return isRecord(value);
}

function fromCamelCaseDetails(errorDetails: Record<string, unknown>): string {
  if (Array.isArray(errorDetails.errors)) {
    const messages = errorDetails.errors
      .filter(isHeliosValidationErrorItem)
      .map((e) => e.errorMessage)
      .filter((msg): msg is string => typeof msg === 'string' && msg.length > 0);
    if (messages.length > 0) return messages.join('\n');
  }
  if (typeof errorDetails.detail === 'string' && errorDetails.detail) return errorDetails.detail;
  return '';
}

function fromPascalCaseDetails(errorDetails: Record<string, unknown>): string {
  if (isRecord(errorDetails.errors)) {
    const messages = Object.values(errorDetails.errors)
      .flatMap((v) => (Array.isArray(v) ? v : [v]))
      .filter((msg): msg is string => typeof msg === 'string' && msg.length > 0);
    if (messages.length > 0) return messages.join('\n');
  }
  if (typeof errorDetails.Detail === 'string' && errorDetails.Detail) return errorDetails.Detail;
  return '';
}

export function parseHeliosError(rtkError: unknown): string {
  const payload = isRecord(rtkError) && 'data' in rtkError ? rtkError.data : rtkError;
  if (!isRecord(payload)) return '';

  if (isRecord(payload.errorDetails)) {
    const message = fromCamelCaseDetails(payload.errorDetails);
    if (message) return message;
  }

  if (isRecord(payload.ErrorDetails)) {
    const message = fromPascalCaseDetails(payload.ErrorDetails);
    if (message) return message;
  }

  if (typeof payload.detail === 'string' && payload.detail) return payload.detail;
  if (typeof payload.Detail === 'string' && payload.Detail) return payload.Detail;

  return '';
}
